import { render } from "./ORGANIZATION_MANAGEMENT.vue?vue&type=template&id=8f593f4c&scoped=true"
import script from "./ORGANIZATION_MANAGEMENT.vue?vue&type=script&lang=js"
export * from "./ORGANIZATION_MANAGEMENT.vue?vue&type=script&lang=js"

import "./ORGANIZATION_MANAGEMENT.vue?vue&type=style&index=0&id=8f593f4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f593f4c"]])

export default __exports__